import React, { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { getSnapshot } from "mobx-state-tree";
import { Tabs, Tab } from "@blueprintjs/core";
import { Page } from "modules/common/components/page/Page";
import { ACCESS_MENU_LABEL } from "modules/root/components/app/User";
import { can } from "modules/session/auth/access";
import { SessionType } from "modules/session/auth/models/session";
import Functionalities from "../../functionalities";
import { AccessStoreType } from "../models/access-store";
import { AccessMatrix } from "./matrix/AccessMatrix";
import { Roles } from "./roles/Roles";
import styles from "./AccessPage.module.scss";

const NestedTabs = {
  roles: "roles",
  matrix: "matrix",
};

// Классовая страница переведена на функцию вместе с заменой матрицы: state выбранной
// строки/колонки и буфер копирования ушли в AccessMatrix, componentDidMount — в эффект
const AccessPage = ({ store, session }: AccessPageProps) => {
  const [selectedTab, setSelectedTab] = useState(NestedTabs.roles);
  const canChange = can(Functionalities.ACCESS_EDIT, session.access);

  useEffect(() => {
    store.load();
  }, [store]);

  const setFunctionality = useCallback(
    async (roleId: string, functionality: string, state: boolean) => {
      const role = store.roles.find((e) => e.id === roleId);
      return role ? await role.setFunctionalityAccess(functionality, state) : false;
    },
    [store]
  );

  const replaceAccess = useCallback(
    async (roleId: string, access: string[]) => {
      const role = store.roles.find((e) => e.id === roleId);
      return role ? await role.setWholeAccess(access) : false;
    },
    [store]
  );

  const matrix = (
    <AccessMatrix
      roles={getSnapshot(store.roles)}
      modules={store.accessModules}
      canChange={canChange}
      onToggle={setFunctionality}
      onReplace={replaceAccess}
    />
  );

  const panel = !canChange ? (
    matrix
  ) : (
    <Tabs
      className={`planr-content-tabs-navigation ${styles.nestedTabs} `}
      id="AccessViewTabs"
      selectedTabId={selectedTab}
      renderActiveTabPanelOnly={true}
      onChange={(tab) => setSelectedTab(tab as string)}
    >
      <Tab
        id={NestedTabs.roles}
        title={"Должности"}
        panel={<Roles store={store} setFunctionality={setFunctionality} replaceAccess={replaceAccess} />}
        className="refresh-tabbtn"
      />
      <Tab id={NestedTabs.matrix} title={"Матрица ролей"} panel={matrix} className="refresh-tabbtn" />
    </Tabs>
  );

  return (
    <Page className={styles.page}>
      <Tabs
        className={`${styles.tabs} planr-tabs-navigation`}
        id="AccessTabsPage"
        defaultSelectedTabId="1"
        renderActiveTabPanelOnly={true}
      >
        <Tab id="1" title={canChange ? ACCESS_MENU_LABEL : "Таблица разрешений"} panel={panel} />
      </Tabs>
    </Page>
  );
};

export default observer(AccessPage);

interface AccessPageProps {
  store: AccessStoreType;
  session: SessionType;
}
